module.exports = __webpack_public_path__ + "img/pay-success.d851df3f.svg";